import { useEffect, useCallback, createContext } from "react";
import { API } from "utils/api";
import { showError } from "utils/common";
import { SET_SITE_INFO } from "store/actions";
import { useDispatch } from "react-redux";

export const LoadStatusContext = createContext();

// eslint-disable-next-line
const StatusProvider = ({ children }) => {
  const dispatch = useDispatch();

  const loadStatus = useCallback(async () => {
    try {
      const res = await API.get("/api/status");
      if (!res || !res.data) {
        throw new Error("status empty");
      }
      const { success, data } = res.data;
      let system_name = "";
      if (success) {
        if (!data.chat_link) {
          delete data.chat_link;
        }
        localStorage.setItem("siteInfo", JSON.stringify(data));
        localStorage.setItem("quota_per_unit", data.quota_per_unit);
        localStorage.setItem("display_in_currency", data.display_in_currency);
        dispatch({ type: SET_SITE_INFO, payload: data });
        // 版本提示条已按老板要求移除(频繁发版期间扰民)
        if (data.system_name) {
          system_name = data.system_name;
        }
      } else {
        const backupSiteInfo = localStorage.getItem("siteInfo");
        if (backupSiteInfo) {
          const data = JSON.parse(backupSiteInfo);
          if (data.system_name) {
            system_name = data.system_name;
          }
          dispatch({
            type: SET_SITE_INFO,
            payload: data,
          });
        }
        showError("无法正常连接至服务器！");
      }

      if (system_name) {
        document.title = system_name;
      }
    } catch (e) {
      // 后端 504/断连时拦截器可能返回 undefined，兜底用本地缓存，避免登录页白屏
      const backupSiteInfo = localStorage.getItem("siteInfo");
      if (backupSiteInfo) {
        try {
          const data = JSON.parse(backupSiteInfo);
          dispatch({ type: SET_SITE_INFO, payload: data });
          if (data.system_name) document.title = data.system_name;
        } catch (_) {
          /* ignore */
        }
      }
    }
  }, [dispatch]);

  useEffect(() => {
    loadStatus().then();
  }, [loadStatus]);

  return (
    <LoadStatusContext.Provider value={loadStatus}>
      {" "}
      {children}{" "}
    </LoadStatusContext.Provider>
  );
};

export default StatusProvider;
